// Constantes para geração de relatórios de analytics

export const REPORT_STATUS = {
  PROCESSED: "PROCESSED",
  WAITING: "WAITING",
  PENDING: "PENDING",
  ERROR: "ERROR",
};

export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

// INFORMACP-4684: o relatorio roda em segundo plano e o arquivo fica 24h disponivel no S3. O cap
// anterior (60 tentativas = 2 minutos) era menor que o tempo real de geracao (~4 minutos), entao a
// tela desistia de um arquivo que ficava pronto. Elevado para 10 minutos, com folga sobre o tempo
// medido. Nao e otimizacao: e para nao descartar relatorio pronto.
export const POLLING_CONFIG = {
  INTERVAL_MS: 2000, // 2 segundos
  MAX_ATTEMPTS: 300, // 10 minutos de espera (300 * 2 segundos)
  TIMEOUT_MS: 600000, // 10 minutos em milissegundos
};

// Codigo de negocio devolvido pelo backend quando nao ha dados para os filtros informados. Nao e
// erro: a tela mostra estado vazio.
export const NO_ANALYTICS_FOR_FILTERS_CODE = -48013;
